import { handleFloatingPromise } from "@solvari/utils";

import { initExpertSite } from "./expertSite";

import "../styles/linkbuilding_3.css";

handleFloatingPromise(initExpertSite());
